import { _isNil } from '@/littledash';
import type { CellValue, RowObject } from '@/support/hot.types';

/**
 * Reads a Handsontable cell value as text. Handsontable types cell values as `unknown`, and pasted or
 * programmatic values can be numbers or booleans even in text cells, so those are stringified. Values
 * with no text form (arrays, objects) read as `null`. `null` and `undefined` pass through so data
 * setters can still tell a cleared cell from a read.
 */
export const cellText = (value: CellValue): string | null | undefined => {
  if (_isNil(value) || typeof value === 'string') {
    return value;
  }
  return typeof value === 'number' || typeof value === 'boolean' ? String(value) : null;
};

/**
 * Whether a cell value or source row is a plain object row, as opposed to an array row or a scalar.
 */
export const isRowObject = (value: CellValue): value is RowObject =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
